import { useEffect, useState } from "react";
import { Lock, X } from "lucide-react";

const COOKIE_BANNER_DELAY_MS = 800;

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem("strombaron_cookie_consent");
    if (!v) setTimeout(() => setShow(true), COOKIE_BANNER_DELAY_MS);
  }, []);

  const act = (value) => {
    localStorage.setItem("strombaron_cookie_consent", value);
    setShow(false);
    if (value === "accepted" && window.gtag) {
      window.gtag("consent", "update", { analytics_storage: "granted" });
    }
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100vw-2rem)] max-w-2xl animate-fade-up" data-testid="cookie-banner">
      <div className="bg-brand-inverse text-brand-onInverse rounded-3xl shadow-[0_20px_60px_-10px_rgba(0,0,0,0.45)] p-5 sm:p-6 flex flex-col sm:flex-row items-start gap-4">
        <div className="w-10 h-10 rounded-2xl bg-white/10 border border-white/15 flex items-center justify-center flex-shrink-0">
          <Lock className="w-4 h-4" style={{ color: 'var(--brand-green-neon)' }} />
        </div>
        <div className="flex-1">
          <p className="font-heading font-black text-white text-base tracking-tight">Cookies & Datenschutz</p>
          <p className="mt-1.5 text-sm text-neutral-300 leading-relaxed">
            Wir nutzen Cookies zur Verbesserung der Nutzererfahrung und für anonymisierte Analysen.
            Details in der <a href="/datenschutz" className="underline text-white hover:text-brand-energy">Datenschutzerklärung</a>.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => act("accepted")}
              className="btn-green rounded-full px-5 py-2 text-sm font-semibold"
              data-testid="cookie-accept"
            >
              Akzeptieren
            </button>
            <button
              onClick={() => act("declined")}
              className="rounded-full px-5 py-2 text-sm font-semibold border border-white/20 text-white hover:bg-white/10 transition"
              data-testid="cookie-decline"
            >
              Ablehnen
            </button>
          </div>
        </div>
        <button
          onClick={() => act("declined")}
          className="p-1.5 rounded-lg hover:bg-white/10 transition"
          data-testid="cookie-close"
          aria-label="Schließen"
        >
          <X className="w-4 h-4 text-neutral-400" />
        </button>
      </div>
    </div>
  );
}
